<template>
	<div :class="{'desktop-tutorial-consultation-mode': isDesktop, 'mobile-tutorial-consultation-mode': !isDesktop}">
		<div class="blog-card-container_title_view no-rem">
			<h2>{{ t('editor_tutorial_consultation') }}</h2>
			<span >
				<nuxt-link :to="`/${locale}/tutorialConsultation`" class="link_color">
					<span>{{ t('editor_check_more') }}</span>
					<!-- <i class="iconfont icon-icon_to"></i> -->
				</nuxt-link>
			</span>
		</div>

		<div class="blog-card-container">
			<tutorialConsultationCard
				v-for="article in latestArticles"
				:key="article._id"
				:article="article"
			/>
		</div>
	</div>
</template>

<script setup lang='ts'>
import { computed } from 'vue';
import type { BlogArticle } from '@/types/blog';
import tutorialConsultationCard from '@/components/tutorialConsultationCom/indexCard.vue';

const { t, locale } = useI18n();

const LATEST_CATEGORY = '1';

/**
 * 获取“最新动态”分类文章
 * - category = 1 时不额外筛选分类，直接取全站最新文章
 * - 统一映射 detail 页跳转路径，带上 category 参数
 */
async function fetchLatestArticles() {
	const code = locale.value;

	const baseQuery = queryContent<BlogArticle>(`/tutorial/${code}`)
		.where({ _extension: 'md' })
		.without(['body', 'excerpt'])
		.sort({ date: -1 });

	const results = await baseQuery.find();

	return results
		.filter(article => article._path !== '/tutorialConsultation')
		.slice(0, 3)
		.map(article => ({
			...article,
			toPath: `/${code}/tutorialConsultation/${article.url || article.title}?category=${LATEST_CATEGORY}`,
		})) as BlogArticle[];
}

const { data: latestPayload } = useAsyncData(
	'tutorial-consultation-latest',
	async () => fetchLatestArticles(),
	{
		watch: [() => locale.value],
	}
);

const latestArticles = computed(() => latestPayload.value ?? []);


const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
</script>

<style scoped lang='scss'>
@use './index.scss' as *;
@use './mobile.scss' as *;
</style>